<template>
    <div class="field">
        <div class="control has-icons-left">
            <input v-model="transmission"
                   v-bind:class="{ 'is-danger': error && error.length > 0 }"
                   class="input"
                   type="text"
                   placeholder="Type Transmission">
            <span class="icon is-small is-left">
                <i class="fas fa-cogs"></i>
            </span>
            <p v-if="error && error.length > 0" class="help is-danger">{{ error[0] }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            transmission: {
                get: function () {
                    return this.$store.getters.getNewCarTransmission
                },
                set: function (value) {
                    this.$store.dispatch('setNewCarTransmission', value)
                }
            },
            error: {
                get: function () {
                    return this.$store.getters.getNewCarErrorTransmission
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Create/Inputs/TransmissionInput.vue